import {Component, ChangeDetectionStrategy, inject, signal} from '@angular/core';
import {NavbarComponent} from '@shared/components/navbar/navbar.component';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  imports: [
    NavbarComponent,
    RouterOutlet,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  readonly activatedRoute = inject(Router);
  readonly showLandingPageHeader = signal<boolean>(false);

  constructor() {
    this.activatedRoute.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log(event.url, 'event.url')
        if (event.url == '/') {
          this.showLandingPageHeader.set(false)
        } else {
          this.showLandingPageHeader.set(true)

        }
      }
    })
  }
}
